import { configureStore, combineReducers, ThunkAction, ThunkDispatch } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { Action } from "redux";

import samplesSearch from "store/samplesSearch/samplesSearchSlice";
import chatwoot from "store/chatwoot/chatwootSlice";
import categories from "store/categories/categoriesSlice";
import tags from "store/tags/tagsSlice";
import global from "store/global/globalSlice";
import { OrderFormSliceReducer } from "@/lib/priceCalculator";

const appReducer = combineReducers({
  samplesSearch,
  categories,
  chatwoot,
  tags,
  global,
  orderForm: OrderFormSliceReducer,
});

const devTools = !!process.env.REACT_APP_DEVTOOLS || process.env.NODE_ENV !== "production";

export const store = configureStore({
  reducer: appReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      devTools,
    }),
});

export type AppStore = typeof store;
export type AppState = ReturnType<AppStore["getState"]>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, AppState, unknown, Action>;

export type AppGetState = () => AppState;
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
export type LocalDispatch = ThunkDispatch<AppState, unknown, Action>;
export const useAppDispatch = (): LocalDispatch => useDispatch<LocalDispatch>();
